import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex mob-flex-direction position-relative flex-column",
  style: {"padding-top":"229px"}
}
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "container__headings col-sm-12 col-md-6 col-lg-7 d-flex flex-column w-100" }
const _hoisted_4 = { class: "serviceTypeButtons align-items-center align-items-md-start" }
const _hoisted_5 = { class: "serviceType mt-lg-5 mt-4 ms-4 ms-md-0" }
const _hoisted_6 = {
  class: "ml-5",
  for: "withDriver"
}
const _hoisted_7 = {
  class: "ml-5",
  for: "roundTrip"
}
const _hoisted_8 = { class: "start-0 w-100 formComponent mt-lg-4 mt-md-3 mt-sm-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_CheckBoxComponent = _resolveComponent("CheckBoxComponent")!
  const _component_RentComponent = _resolveComponent("RentComponent")!
  const _component_TransportationComponent = _resolveComponent("TransportationComponent")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_ButtonComponent, {
              id: "rentButton",
              class: _normalizeClass(["typeButtons me-lg-3", [_ctx.serviceType === _ctx.ServiceTypes.SERVICE_RENT ? 'active' : null]]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onServiceTypeChange(_ctx.ServiceTypes.SERVICE_RENT)))
            }, {
              btnContent: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('minibus_rental')), 1)
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_ButtonComponent, {
              id: "transportationButton",
              class: _normalizeClass(["typeButtons", [_ctx.serviceType === _ctx.ServiceTypes.SERVICE_TRANSPORTATION ? 'active' : null]]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onServiceTypeChange(_ctx.ServiceTypes.SERVICE_TRANSPORTATION)))
            }, {
              btnContent: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('passenger_transportation')), 1)
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.serviceType === _ctx.ServiceTypes.SERVICE_RENT)
              ? (_openBlock(), _createBlock(_component_CheckBoxComponent, {
                  key: 0,
                  onOnClick: _ctx.isWithDriver,
                  state: _ctx.store.state.order.withDriver,
                  id: 'withDriver',
                  name: "withDriver",
                  class: "checkbox-default"
                }, {
                  "checkbox-text": _withCtx(() => [
                    _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('minibus_rent_with_driver')), 1)
                  ]),
                  _: 1
                }, 8, ["onOnClick", "state"]))
              : _createCommentVNode("", true),
            (_ctx.serviceType === _ctx.ServiceTypes.SERVICE_TRANSPORTATION)
              ? (_openBlock(), _createBlock(_component_CheckBoxComponent, {
                  key: 1,
                  onOnClick: _ctx.isRoundTrip,
                  state: _ctx.store.state.order.roundTrip,
                  id: 'roundTrip',
                  name: "roundTrip",
                  class: "checkbox-default"
                }, {
                  "checkbox-text": _withCtx(() => [
                    _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('round_trip')), 1)
                  ]),
                  _: 1
                }, 8, ["onOnClick", "state"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.serviceType === _ctx.ServiceTypes.SERVICE_RENT)
          ? (_openBlock(), _createBlock(_component_RentComponent, {
              key: 0,
              "with-driver": _ctx.store.state.order.withDriver
            }, null, 8, ["with-driver"]))
          : _createCommentVNode("", true),
        (_ctx.serviceType === _ctx.ServiceTypes.SERVICE_TRANSPORTATION)
          ? (_openBlock(), _createBlock(_component_TransportationComponent, {
              key: 1,
              "round-trip": _ctx.store.state.order.roundTrip
            }, null, 8, ["round-trip"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}